import { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import * as authApi from "../services/authApi";
// import useOtp, { STATUS, TYPES } from "./useOtp";
import TokenPersistenceManager from "../../../../services/tokenPersistenceManager";
import { SET_TOKEN } from "../services/authReducer";
import { SET_PROFILE } from "../../SettingsModule/services/profileReducer";

// export { TYPES, STATUS };

// let _data;

export default function useAuth() {
  const dispatch = useDispatch();
  const isAuthenticated = useSelector(state => state.auth.isAuthenticated);

  const [loginError, setLoginError] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  //   const { onSendOtp, onVerifyOtp, onResendOtp, status, reset } = useOtp();

  const handleLoginSuccess = (userData, tokens) => {
    const { accessToken, refreshToken } = tokens;
    // Remove sensitive data before storing in Redux
    const userDataToStore = { ...userData };
    delete userDataToStore.accessToken;
    delete userDataToStore.refreshToken;

    // Store tokens
    TokenPersistenceManager.setTokens({ accessToken, refreshToken });
    TokenPersistenceManager.setToken(accessToken);

    // Update Redux state
    dispatch(SET_TOKEN({ token: accessToken }));
    dispatch(SET_PROFILE({ storeUser: userDataToStore }));

    return true;
  };

  const handleLoginError = error => {
    const errorMessage =
      error.response?.data?.error?.message || "Something went wrong!";
    setLoginError(errorMessage);
    return false;
  };

  const onAdminLogin = async (email_username, password) => {
    setIsLoading(true);
    setLoginError("");

    try {
      const response = await authApi.adminLogin(email_username, password);

      if (!response.data.success) {
        return handleLoginError({ response });
      }

      const { admin } = response.data.data;
      return handleLoginSuccess(admin, {
        accessToken: admin.accessToken,
        refreshToken: admin.refreshToken,
      });
    } catch (error) {
      return handleLoginError(error);
    } finally {
      setIsLoading(false);
    }
  };

  const onUserLogin = async (storeId, email_username, password) => {
    setIsLoading(true);
    setLoginError("");

    try {
      const response = await authApi.userLogin(
        storeId,
        email_username,
        password,
      );

      if (!response.data?.success) {
        return handleLoginError({ response });
      }

      const { user } = response.data.data;
      return handleLoginSuccess(user, {
        accessToken: user.accessToken,
        refreshToken: user.refreshToken,
      });
    } catch (error) {
      return handleLoginError(error);
    } finally {
      setIsLoading(false);
    }
  };

  //   const onSignup = ({ email, password, fullName, cipher }) => {
  //     _data = { email, password, fullName, cipher };
  //     return onSendOtp(email, TYPES.SIGNUP);
  //   };

  //   const _onVerifyOtp = async otp => {
  //     if (!(await onVerifyOtp(otp))) return false;
  //     try {
  //       const res = await authApi.signup(_data);
  //       if (!res.data?.success) {
  //         throw new Error(res.data);
  //       }
  //       return true;
  //     } catch (err) {
  //       return false;
  //     }
  //   };

  //   const onLogin = async ({ email, password, rememberMe }) => {
  //     try {
  //       setLoginError("");
  //       const response = await authApi.login(email, password);
  //       if (!response.data?.success) {
  //         setLoginError(response.data?.error);
  //         return false;
  //       }
  //       const { data, token } = response.data;
  //       TokenPersistenceManager.setToken(token);
  //       dispatch(SET_TOKEN({ token }));
  //       dispatch(SET_PROFILE({ ...data[0] }));

  //       return true;
  //     } catch {
  //       setLoginError("Something went wrong!");
  //       return false;
  //     }
  //   };

  return {
    isAuthenticated,
    loginError,
    onAdminLogin,
    onUserLogin,
    isLoading,
    // onLogin,
    // onResendOtp,
    // onSignup,
    // onVerifyOtp: _onVerifyOtp,
    // reset,
    // status,
  };
}
